module.exports = __webpack_public_path__ + "img/background1.885c60e1.jpg";